import axios from 'axios';
import { md5Encrypt } from '@/utils/MD5.js';
import { BASE_URL, TIMEOUT } from '@/config/env.js';


import router from '@/router/index.js';

// Create Axios instance
const service = axios.create({
  baseURL: BASE_URL,
  timeout: TIMEOUT
});

// Request interceptor
service.interceptors.request.use(
  (config) => {
    // Add timestamp header
    const beijingTime = new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Shanghai' }));
    const formattedTime = `${beijingTime.getFullYear()}${String(beijingTime.getMonth() + 1).padStart(2, '0')}${String(beijingTime.getDate()).padStart(2, '0')}${String(beijingTime.getHours()).padStart(2, '0')}${String(beijingTime.getMinutes()).padStart(2, '0')}${String(beijingTime.getSeconds()).padStart(2, '0')}`;
    config.headers['X-TIMESTAMP'] = formattedTime;

    // Generate X-Sign header with MD5
    const dataToSign = config.method === 'get' ? config.params : config.data;
    const targetData = dataToSign ? dataToSign : {};
    const sortedData = Object.keys(targetData).sort().reduce((acc, key) => {
      acc[key] = targetData[key];
      return acc;
    }, {});

    const signStr = JSON.stringify(sortedData) + '95f9fa6d49v442add05f1c54d63749eda';
    config.headers['X-Sign'] = md5Encrypt(signStr);

    // Add sx-token header if token exists
    const token = localStorage.getItem('sx-token');
    console.log('token:-----------------', token);
    if (token) {
      config.headers['sx-token'] = token;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
service.interceptors.response.use(
  (response) => {
    const res = response.data;

    // Handle error responses
   if(res.code === 10001 || res.code === 500){
      // Handle 401 Unauthorized error (token expired or invalid)
      console.error('401 Unauthorized:', res.message || '登录已过期，请重新登录');

      // Clear local storage to ensure complete logout
      localStorage.removeItem('sx-token');
      localStorage.removeItem('isLoggedIn');

        router.push({
              path: '/login',
              query: {} // 保留所有查询参数
            });
    }else if (res.code !== 200 && res.message) {
      console.error('API Error:', res.message);
    }

    return response;
  },
  (error) => {
    // Handle network errors
    const errorMessage = error.response && error.response.status === 404 ? '请求错误，未找到该资源' : '网络错误';
    console.error('Network Error:', errorMessage);

    return Promise.reject(error);
  }
);

// HTTP methods
export function httpPost(url, data) {
  return service.post(url, data);
}

export function httpGet(url, params) {
  return service.get(url, { params });
}

export function httpDelete(url, params) {
  return service.delete(url, { params });
}

export function httpPut(url, data) {
  return service.put(url, data);
}

export function httpPatch(url, data) {
  return service.patch(url, data);
}

// Export default
export default service;



// WEBPACK FOOTER //
// ./src/api/request.js